import type { ActionFlatProps } from '~shared/ui/atoms';

import { StyledAction } from './styles';

type Props = ActionFlatProps;

export const ActionFlatSecondary = (props: Props) => (
	<StyledAction {...props} />
);
